import ls from "../../libs/helpers/LocalStorageWrapper";
import { createNamespacedHelpers } from "vuex";
import Interval from "../../libs/timer/Interval";
const { mapGetters, mapState } = createNamespacedHelpers("global");
const USER_NOT_FOUND = 7001;
const RESEND_EMAIL_DELAY = 1000 * 60 * 5; // five minutes
import GTM from "../../libs/api/GTM";
import env from "../../libs/tools/Environment";
const ls_key = "subscribe_data";
export default {
  data() {
    return {
      dynamic: true,
      is_loaded: false,
      email: "",
      mailer_profile: null,
      agreements: false,
      timer: null,
      can_resend_email: false,
      is_input_disabled: true,
      error: null,
      error_params: null,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["isUserInProject", "isUserProcessed"]),
    isEmailValid() {
      // eslint-disable-next-line
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    },
    isButtonActive() {
      return this.isEmailValid && this.agreements;
    },
    getButtonClass() {
      return { "button--disabled": !this.isButtonActive };
    },
    isSubscribed() {
      return (
        this.mailer_profile &&
        this.mailer_profile.subscribed_at &&
        !this.mailer_profile.unsubscribed_at
      );
    },
    isVerify() {
      return this.mailer_profile && this.mailer_profile.email_verified;
    },
    isSubscribedAndVerify() {
      return this.isSubscribed && this.isVerify;
    },
    isEmailAlreadySend() {
      const subscribe_data = ls.getItem(ls_key);
      if (subscribe_data) {
        const email_send_ts = subscribe_data.email_send_ts;
        if (+new Date() - email_send_ts < RESEND_EMAIL_DELAY) {
          return true;
        }
      }
      return false;
    },
    canChangeEmail() {
      return (
        this.mailer_profile &&
        (this.mailer_profile.can_change_email || this.mailer_profile.can_change_email_in_account)
      );
    },
  },
  created() {
    if (env.isPromoPage()) {
      this.getMailerApiInfo("run");
    } else {
      document.addEventListener("init_vue_components", () => {
        this.getMailerApiInfo();
      });
    }
  },
  methods: {
    changeEmail() {
      this.is_input_disabled = false;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    createTimer() {
      this.destroyTimer();
      const subscribe_ls_data = ls.getItem(ls_key);

      const timer_ts = subscribe_ls_data ? subscribe_ls_data.email_send_ts : 0;
      const needly_ts = timer_ts + RESEND_EMAIL_DELAY;
      let current_ts = +new Date();
      if (current_ts > needly_ts) {
        this.can_resend_email = true;
        return false;
      } else {
        this.can_resend_email = false;
      }
      this.timer = new Interval(() => {
        current_ts = +new Date();
        if (current_ts > needly_ts) {
          this.can_resend_email = true;
          this.destroyTimer();
        }
      }, 1000);
    },
    destroyTimer() {
      if (this.timer) {
        this.timer.destroy();
        this.timer = null;
      }
    },
    resendEmail() {
      this.subscribe();
    },
    subscribe() {
      this.error = null;
      this.$api.mailerService
        .accountSubscribe({ email: this.email })
        .run()
        .then(response => {
          if (response.data.result && response.data.result.status === "ok") {
            GTM.sendEvent("ch.mailer.subscribed", { userID: this.user.id });
            this.can_resend_email = false;
            ls.setItem(ls_key, { email_send_ts: +new Date() });
            this.getMailerApiInfo("run");
          }
          if (response.data.error) {
            this.error = response.data.error.code;
            this.error_params = { email: this.mailer_profile.email };
          }
        });
    },
    getMailerApiInfo(method = "batch") {
      return this.$api.mailerService
        .getAccountSubscriptionsStatus()
        [method]()
        .then(response => {
          if (!response.data.result) {
            this.is_loaded = true;
            return false;
          }
          //only for init (batch) request
          if (response.data.result.code === USER_NOT_FOUND && method === "batch") {
            if (this.user.origin === "mailru" || this.user.origin === "email") {
              this.email = this.user.login;
            }
          } else {
            this.email = response.data.result.email;
          }
          this.mailer_profile = response.data.result;

          if (!this.isSubscribedAndVerify && this.isSubscribed) {
            this.createTimer();
          }

          this.is_loaded = true;
          return true;
        });
    },
  },
};
